import { StorePaymentConfiguration } from "@/common/models/StorePaymentConfiguration";
import { CalendarConfiguration } from "@/common/models/CalendarConfiguration";
import { ClickAndCollectConfiguration } from "@/common/models/ClickAndCollectConfiguration";
import { PosConfiguration } from "@/common/models/PosConfiguration";
import { StoreYotiConfiguration } from "@/common/models/StoreYotiConfiguration";

export class StoreConfiguration {
  ageVerificationConfiguration: StoreYotiConfiguration | null;
  paymentConfiguration: StorePaymentConfiguration | null;
  posConfiguration: PosConfiguration | null;
  clickAndCollectConfiguration: ClickAndCollectConfiguration | null;
  calendarConfiguration: CalendarConfiguration | null;
  looseProduceBarcode: string | null;
  retainLeadingZeros: boolean | null;
  promotionAllowed: boolean | null;
  maxPromotionCountPerCategory: number | null;

  constructor(
    ageVerificationConfiguration: StoreYotiConfiguration | null,
    paymentConfiguration: StorePaymentConfiguration | null,
    posConfiguration: PosConfiguration | null,
    clickAndCollectConfiguration: ClickAndCollectConfiguration | null,
    calendarConfiguration: CalendarConfiguration | null,
    looseProduceBarcode: string | null,
    retainLeadingZeros: boolean | null,
    promotionAllowed: boolean | null,
    maxPromotionCountPerCategory: number | null
  ) {
    this.ageVerificationConfiguration = ageVerificationConfiguration;
    this.paymentConfiguration = paymentConfiguration;
    this.posConfiguration = posConfiguration;
    this.clickAndCollectConfiguration = clickAndCollectConfiguration;
    this.calendarConfiguration = calendarConfiguration;
    this.looseProduceBarcode = looseProduceBarcode;
    this.retainLeadingZeros = retainLeadingZeros;
    this.promotionAllowed = promotionAllowed;
    this.maxPromotionCountPerCategory = maxPromotionCountPerCategory;
  }
}
